<template>
    <div>
        <div v-for="(section, i) in pageSections" class="card mb-3">
            <div class="card-header py-1 pe-2 d-flex align-items-center">
                <span class="flex-fill">
                    Section {{ i + 1 }}
                    <code class="text-secondary"> <small>#{{ section.id }}</small></code>
                </span>

                <div class="dropdown d-inline-block">
                    <Button ref="button" class="btn-sm" data-bs-toggle="dropdown"><i
                        class="bi bi-three-dots"/></Button>
                    <div class="dropdown-menu">
                        <div class="dropdown-item">
                            <PageContentSectionsTemplateMenu :section-id="section.id"/>
                        </div>
                        <div class="dropdown-item">
                            <PageContentSectionsContainerMenu :section-id="section.id"/>
                        </div>
                    </div>
                </div>
                <Button @click.native="moveSectionUp(i)" class="btn-sm"><i class="bi bi-chevron-up"/></Button>
                <Button @click.native="moveSectionDown(i)" class="btn-sm"><i class="bi bi-chevron-down"/></Button>
                <Button @click.native="deleteSection(i)" class="btn-sm"><i class="bi bi-x-lg"/></Button>
            </div>

            <div class="card-body">
                <div v-for="(area, k) in section.areas" class="card" :class="{'mb-3': k < section.areas.length - 1}">
                    <div class="card-header py-1 pe-2 d-flex align-items-center">
                        <span class="flex-fill">
                            {{ area.text }}
                            <code class="text-secondary"> <small>{{ area.value }}</small></code>
                        </span>

                        <Button @click.native="showAddContentModal(section.id, area.value)" class="btn-sm"><i
                            class="bi bi-plus-lg"/></Button>
                    </div>
                    <PageContentArea :page-section-link-id="section.id" :area="area.value"/>
                </div>
            </div>
        </div>

        <Button @click.native="addSection"><i class="bi bi-plus-lg"/> Add section</Button>
    </div>
</template>

<script>
import PageContentArea from "./PageContentArea.vue"
import Button from "../Button.vue"
import PageContentSectionsTemplateMenu from "./PageContentSectionsTemplateMenu.vue"
import PageContentSectionsContainerMenu from "./PageContentSectionsContainerMenu.vue"

export default {
    name: "PageContentSections",
    components: {PageContentSectionsContainerMenu, PageContentSectionsTemplateMenu, Button, PageContentArea},
    props: {
        pageId: Number
    },
    computed: {
        pageSections() {
            return this.$store.state.pageSections.items.filter(o => o.pageId === this.pageId)
        }
    },
    methods: {
        async addSection() {
            await this.$store.dispatch('request/put', {url: 'api/page-section/' + this.pageId})

            await this.$store.dispatch('pageSections/init', true)
        },
        async moveSectionUp(i) {
            if (i === 0) {
                console.log('The first section cannot be moved higher.')
                return
            }

            const section = this.pageSections[i]
            await this.$store.dispatch('request/patch', {url: 'api/page-section/' + section.id + '/up'}, {root: true})
            await this.$store.dispatch('pageSections/init', true)
        },
        async moveSectionDown(i) {
            if (i === this.pageSections.length - 1) {
                console.log('The last section cannot be moved lower.')
                return
            }

            const section = this.pageSections[i]
            await this.$store.dispatch('request/patch', {url: 'api/page-section/' + section.id + '/down'}, {root: true})
            await this.$store.dispatch('pageSections/init', true)
        },
        deleteSection(i) {
            const section = this.pageSections[i]

            this.$store.dispatch('modals/show', {
                componentName: 'ConfirmModal',
                obj: {
                    modalTitle: 'Delete section',
                    modalBody: `
                        <p class="alert alert-danger">This <strong>cannot</strong> be undone.</p>
                        <p class="mb-0">Are you sure?</p>
                    `,
                    onConfirm: async () => {
                        await this.$store.dispatch('request/delete', {url: 'api/page-section/' + section.id})

                        await this.$store.dispatch('pageSections/init', true)

                        // Removes any propagated content that was contained within the deleted section
                        // from the content's Page Use control.
                        await this.$store.dispatch('pageContentData/init')
                    }
                }
            }, {root: true})
        },
        showAddContentModal(pageSectionLinkId, contentArea) {
            this.$store.dispatch('modals/show', {
                componentName: 'AddContentModal',
                obj: {
                    onSelect: async (o) => {
                        console.log({pageId: this.pageId, contentId: o.contentId, contentArea})
                        await this.$store.dispatch('request/post', {
                            url: 'api/save-content-to-page',
                            postData: {pageId: this.pageId, pageSectionLinkId, contentId: o.contentId, contentArea}
                        })

                        //await this.$store.dispatch('pageSections/init', true)

                        await this.$store.dispatch('pageContentData/init')
                    }
                }
            })
        }
    }
}
</script>

<style scoped>

</style>